import {
  FaNetworkWired,
  FaServer,
  FaLock,
  FaTools,
  FaShieldAlt,
  FaProjectDiagram,
  FaUserTie,
  FaClock,
  FaEye,
  FaCloudUploadAlt,
} from "react-icons/fa";
import img1 from "../../image/Image _ Page/Service_popup/Networking solution-main.jpeg";
import img2 from "../../image/Image _ Page/Service_popup/Networking solution-1.jpeg";
import img3 from "../../image/Image _ Page/Service_popup/Networking solution-2.jpg";
import "../../Components/style/Network.css"; // Custom CSS file for styling

const Networking = () => {
  const solutions = [
    {
      icon: <FaProjectDiagram size={26} />,
      title: "Network Design",
      description:
        "Create and deploy efficient, scalable network architectures aligned with your business goals.",
    },
    {
      icon: <FaServer size={26} />,
      title: "Server Management",
      description:
        "Optimize performance and reliability with proactive server management and maintenance.",
    },
    {
      icon: <FaLock size={26} />,
      title: "Network Security",
      description:
        "Protect your infrastructure with firewalls, VPNs, intrusion prevention, and threat detection systems.",
    },
    {
      icon: <FaProjectDiagram size={26} />,
      title: "Unified Communication Systems",
      description:
        "Enable effortless collaboration with advanced VoIP, video conferencing, and messaging solutions.",
    },
    {
      icon: <FaTools size={26} />,
      title: "Network Monitoring",
      description:
        "Proactively monitor your network to detect and resolve issues before they affect operations.",
    },
    {
      icon: <FaShieldAlt size={26} />,
      title: "Advanced Protection",
      description:
        "Implement cutting-edge tools to safeguard against cyber threats and ensure data integrity.",
    },
  ];

  const solutionStyles = {
    section: {
      backgroundColor: "#eef2fb",
      padding: "60px 50px",
      boxSizing: "border-box",
      width: "100%",
      overflow: "hidden",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: "24px",
      maxWidth: "1200px",
      margin: "0 auto",
      boxSizing: "border-box",
    },
    card: {
      backgroundColor: "#ffffff",
      borderRadius: "16px",
      padding: "30px 26px",
      display: "flex",
      flexDirection: "column",
      boxSizing: "border-box",
      minWidth: 0,
    },
    iconBox: {
      width: "56px",
      height: "56px",
      borderRadius: "14px",
      backgroundColor: "#e3ebfd",
      color: "#3b6df0",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "20px",
    },
    title: {
      fontSize: "17px",
      fontWeight: 700,
      color: "#111827",
      marginBottom: "8px",
    },
    text: {
      fontSize: "14px",
      color: "#6b7280",
      lineHeight: 1.7,
      marginBottom: "16px",
    },
    readMore: {
      color: "#3b6df0",
      fontWeight: 700,
      fontSize: "14.5px",
      textDecoration: "none",
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      cursor: "pointer",
    },
  };

  const heroStyles = {
    section: {
      backgroundColor: "#ffffff",
      padding: "70px 50px",
    },
    wrapper: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: "40px",
      maxWidth: "1200px",
      margin: "0 auto",
    },
    imageBox: {
      flex: "1 1 420px",
    },
    image: {
      width: "100%",
      height: "340px",
      objectFit: "cover",
      borderRadius: "18px",
    },
    textBox: {
      flex: "1 1 420px",
      backgroundColor: "#ffffff",
      borderRadius: "18px",
      padding: "10px",
    },
    subtitle: {
      color: "#3b6df0",
      fontWeight: 700,
      fontSize: "13px",
      letterSpacing: "0.8px",
      textTransform: "uppercase",
      marginBottom: "12px",
    },
    title: {
      fontSize: "28px",
      fontWeight: 800,
      color: "#111827",
      lineHeight: 1.3,
      marginBottom: "18px",
    },
    highlight: {
      color: "#3b6df0",
    },
    description: {
      fontSize: "14.5px",
      color: "#6b7280",
      lineHeight: 1.8,
      marginBottom: "14px",
    },
  };

  const qualityStyles = {
    section: {
      backgroundColor: "#f4f7fe",
      padding: "70px 50px",
    },
    wrapper: {
      display: "flex",
      flexWrap: "wrap",
      gap: "40px",
      maxWidth: "1200px",
      margin: "0 auto",
      alignItems: "flex-start",
    },
    content: {
      flex: "1 1 460px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
    },
    eyebrow: {
      fontSize: "13.5px",
      color: "#6b7280",
      marginBottom: "10px",
      textAlign: "center",
    },
    heading: {
      fontSize: "26px",
      fontWeight: 800,
      color: "#111827",
      lineHeight: 1.35,
      marginBottom: "26px",
      textAlign: "center",
    },
    listItem: {
      backgroundColor: "#ffffff",
      borderRadius: "14px",
      padding: "18px 20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      gap: "16px",
      marginBottom: "14px",
      width: "100%",
      maxWidth: "460px",
    },
    listIconBox: {
      width: "46px",
      height: "46px",
      borderRadius: "12px",
      backgroundColor: "#e3ebfd",
      color: "#3b6df0",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    },
    listHead: {
      fontSize: "15px",
      fontWeight: 700,
      color: "#111827",
      marginBottom: "4px",
    },
    listText: {
      fontSize: "13.5px",
      color: "#6b7280",
      lineHeight: 1.6,
    },
    imageWrap: {
      flex: "1 1 420px",
    },
    image: {
      width: "100%",
      height: "420px",
      objectFit: "cover",
      borderRadius: "18px",
    },
  };

  return (
    <div>
      {/**this is banner section  */}
      <div style={{ position: "relative", width: "100%", height: "60vh" }}>
        {/* Image */}
        <img
          src={img1}
          alt="Inner Banner"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",

          }}
        />

        {/* Centered Text */}
        <h2
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "white",
            fontSize: "3rem",
            fontWeight: "bold",
            textShadow: "2px 2px 8px rgba(0, 0, 0, 0.7)",
          }}
        >
          Networking solution
        </h2>
      </div>
      {/* Hero Section — restyled inline to match blue/white reference */}
      <section style={heroStyles.section}>
        <div style={heroStyles.wrapper}>
          {/* Image Box */}
          <div style={heroStyles.imageBox}>
            <img src={img2} alt="Networking Service" style={heroStyles.image} />
          </div>

          {/* Text Box */}
          <div style={heroStyles.textBox}>
            <h5 style={heroStyles.subtitle}>Networking Solutions</h5>
            <h2 style={heroStyles.title}>
              Build a Solid Foundation with{" "}
              <span style={heroStyles.highlight}>Networking Services</span>
            </h2>
            <p style={heroStyles.description}>
              Optimize your IT infrastructure with reliable and scalable networking solutions. Our
              expertise ensures seamless connectivity, enhanced security, and efficient management of
              your network.
            </p>
            <p style={heroStyles.description}>
              From network design to implementation, we offer comprehensive solutions tailored to meet
              your business needs. Stay connected and secure with our innovative networking services.
            </p>
          </div>
        </div>
      </section>

      {/* Solutions Section — static 3-column grid, same data as before */}
      <section style={solutionStyles.section}>
        <style>{`
          @media (max-width: 900px) {
            .solutions-grid { grid-template-columns: repeat(2, 1fr) !important; }
          }
          @media (max-width: 600px) {
            .solutions-grid { grid-template-columns: 1fr !important; }
          }
        `}</style>
        <div className="container">
          <div className="solutions-grid" style={solutionStyles.grid}>
            {solutions.map((item, index) => (
              <div key={index} style={solutionStyles.card}>
                <div style={solutionStyles.iconBox}>{item.icon}</div>
                <h5 style={solutionStyles.title}>{item.title}</h5>
                <p style={solutionStyles.text}>{item.description}</p>
                <span style={solutionStyles.readMore}>Read More →</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section style={qualityStyles.section}>
        <div style={qualityStyles.wrapper}>
          {/* Left Content Section */}
          <div style={qualityStyles.content}>
            <p style={qualityStyles.eyebrow}>
              Ensuring Exceptional Quality in Networking Infrastructure Services
            </p>
            <h2 style={qualityStyles.heading}>
              Our Commitment to Delivering Reliable and Scalable Networking Solutions
            </h2>

            {/* List of Features */}
            <div style={qualityStyles.listItem}>
              <div style={qualityStyles.listIconBox}>
                <FaUserTie size={22} />
              </div>
              <div>
                <h4 style={qualityStyles.listHead}>Certified Networking Professionals</h4>
                <p style={qualityStyles.listText}>
                  Leverage the expertise of a highly skilled team of network engineers.
                </p>
              </div>
            </div>

            <div style={qualityStyles.listItem}>
              <div style={qualityStyles.listIconBox}>
                <FaNetworkWired size={22} />
              </div>
              <div>
                <h4 style={qualityStyles.listHead}>Reliable Infrastructure</h4>
                <p style={qualityStyles.listText}>
                  Build robust, high-performance, and stable network systems for your business.
                </p>
              </div>
            </div>

            <div style={qualityStyles.listItem}>
              <div style={qualityStyles.listIconBox}>
                <FaCloudUploadAlt size={22} />
              </div>
              <div>
                <h4 style={qualityStyles.listHead}>Scalable Solutions</h4>
                <p style={qualityStyles.listText}>
                  Future-proof your network to meet evolving demands.
                </p>
              </div>
            </div>

            <div style={qualityStyles.listItem}>
              <div style={qualityStyles.listIconBox}>
                <FaClock size={22} />
              </div>
              <div>
                <h4 style={qualityStyles.listHead}>24/7 Monitoring & Support</h4>
                <p style={qualityStyles.listText}>
                  Round-the-clock support to ensure uninterrupted operations.
                </p>
              </div>
            </div>
          </div>

          {/* Right Image Section */}
          <div style={qualityStyles.imageWrap}>
            <img src={img3} alt="Networking Infrastructure" style={qualityStyles.image} />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Networking;
